// @flow
import React from "react";
import type {translate} from "../../../i18next";
import "./OrderFinished.scss";
import InlineNotice from "../../layout/InlineNotice";

type OrderFinishedProps = {
    t: translate,
    paymentAuthorizationFailed: boolean,
    clearOrderDetails: () => void,
	makeCartEmpty: () => void,
    goToStartpage: () => void,
};

class OrderFinished extends React.Component<OrderFinishedProps> {

    componentWillUnmount() {
        this.props.clearOrderDetails();
        this.props.makeCartEmpty();
	}

	render() {
		return (
			<React.Fragment>
                <div className="hpm-orderFinished hpm-emptyCart">
                    <div>
                        <span className={"hpm-orderFinish"}>{this.props.t("cart.finished")}</span>
                        {this.props.paymentAuthorizationFailed &&
                            <InlineNotice kind="error">{this.props.t("cart.paymentApiError")}</InlineNotice>
                        }
                        <button
                            type={"button"}
                            onClick={() => this.props.goToStartpage()}
                            className="hpm-cartButton back">{this.props.t("cart.back")}
                        </button>
                    </div>
                </div>
			</React.Fragment>
		);
	}
}

export default OrderFinished;
